import { OhsAllocationItem } from 'global-components/allocation/OhsAllocatableModels';
import {
  ApiResListsType,
  ApiResponseType,
  OhsApiRequestName,
  OhsApiRequestOptions,
  RequestType,
} from 'global-services/api/OhsApiModels';
import OhsApiRequest from 'global-services/api/OhsApiRequest';
import { ModuleType } from 'global-services/constants/OhsObject';
import { getCurrentTimezone } from 'global-services/OhsDataParse';
import { SafetyPlanAllocListRes } from 'safety-plan/OhsSafetyPlanModels';
import OhsInjuryMgmtRecord from 'injury-mgmt/models/OhsInjuryMgmtRecord';

export const getInjuryMgmtFolderLists = (
  filterInfo: any
): Promise<ApiResListsType<any[]> | null> => {
  return OhsApiRequest(
    RequestType.Module,
    ModuleType.WorkManagement,
    OhsApiRequestName.MasterList,
    {
      forType: ModuleType.Injury,
      filter: filterInfo,
    }
  );
};

export const searchInjuryMgmtFolderLists = (
  searchInfo: any
): Promise<ApiResListsType<any[]> | null> => {
  return OhsApiRequest(
    RequestType.Module,
    ModuleType.WorkManagement,
    OhsApiRequestName.Search,
    searchInfo
  );
};

export const getInjuryMgmtFolder = async (
  _id: string,
  options: OhsApiRequestOptions = {}
): Promise<OhsInjuryMgmtRecord> => {
  const res: OhsInjuryMgmtRecord | null = await OhsApiRequest(
    RequestType.Module,
    ModuleType.WorkManagement,
    OhsApiRequestName.MasterFetch,
    { _id, forType: ModuleType.Injury },
    options
  );
  return res || new OhsInjuryMgmtRecord();
};

export const allocateFolder = (
  _id: string,
  allocationItem: OhsAllocationItem | OhsAllocationItem[]
): Promise<any> => {
  const payload: any = {
    forType: ModuleType.Injury,
    _id,
    to: [],
    tzDateCreated: getCurrentTimezone(),
  };
  if (Array.isArray(allocationItem)) {
    payload.to = allocationItem.map((item) => ({
      _id: item._id,
      type: item.type,
    }));
  } else {
    payload.to = allocationItem;
  }

  return OhsApiRequest(
    RequestType.Module,
    ModuleType.WorkManagement,
    OhsApiRequestName.MasterAllocate,
    payload
  );
};

export const deAllocateFolder = (
  _id: string,
  allocationItem: OhsAllocationItem | OhsAllocationItem[]
): Promise<any> => {
  const payload: any = { forType: ModuleType.Injury, _id, to: [], tz: getCurrentTimezone() };
  if (Array.isArray(allocationItem)) {
    payload.to = allocationItem.map((item) => ({
      _id: item._id,
      type: item.type,
    }));
  } else {
    payload.to = allocationItem;
  }
  return OhsApiRequest(
    RequestType.Module,
    ModuleType.WorkManagement,
    OhsApiRequestName.MasterDeallocate,
    payload
  );
};

export const getFolderAllocationList = (
  docId: string
): Promise<ApiResponseType<SafetyPlanAllocListRes> | null> => {
  return OhsApiRequest(
    RequestType.Module,
    ModuleType.WorkManagement,
    OhsApiRequestName.AllocationList,
    {
      forType: ModuleType.Injury,
      _id: docId,
    }
  );
};

export const getFolderAllocationListByIds = (docIds: string[]): Promise<any> => {
  return OhsApiRequest(
    RequestType.Module,
    ModuleType.WorkManagement,
    OhsApiRequestName.AllocatedList,
    {
      forType: ModuleType.Injury,
      _ids: docIds,
    }
  );
};
